import { render, staticRenderFns } from "./ExamFreedomReport.vue?vue&type=template&id=6b5ff610"
import script from "./ExamFreedomReport.vue?vue&type=script&lang=js"
export * from "./ExamFreedomReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports